import { actions } from './reducer'
// this should only be used with components that are fully migrated to consuming v4 data
import api from 'lib/api/ssapi/secondStepApi.v4'
import { formatError } from 'utils/formatError'
import { isV4Routed } from 'lib/api/ssapi/secondStepApi.router'
import { isFlagOn } from 'utils/featureFlags'

const clearErrors = () => {
  return async dispatch => {
    dispatch(actions.clearErrors())
  }
}

const fetchUserNetSuiteAssets = () => {
  return async dispatch => {
    dispatch(actions.fetchingUserNetSuiteAssets())

    try {
      const { data } = await api.getNetSuiteAssetsForUser()
      dispatch(actions.fetchingUserNetSuiteAssetsSuccess(data))
    } catch (error) {
      dispatch(
        actions.fetchingUserNetSuiteAssetsError({ error: formatError(error) }),
      )
    }
  }
}

const fetchPublishFlows = siteId => {
  return async (dispatch, getState) => {
    dispatch(actions.fetchingPublishFlows())
    try {
      const { data } = await api.getPublishFlows(siteId)
      dispatch(actions.fetchingPublishFlowsSuccess({ siteId, data }))
    } catch (error) {
      dispatch(actions.fetchingPublishFlowsError(formatError(error)))
    }
  }
}

const fetchUserSites = () => {
  return async dispatch => {
    dispatch(actions.fetchingUserSites())

    try {
      const { data } = await api.getUserSites()
      dispatch(actions.fetchingUserSitesSuccess(data))
    } catch (error) {
      dispatch(actions.fetchingUserSitesError(formatError(error)))
    }
  }
}

const postPublishFlows = body => {
  return async (dispatch, getState) => {
    dispatch(actions.postingPublishFlows())
    try {
      const structureVersion = isFlagOn(['BTS-2026_publishWorkflows']) ? 2 : 1
      const { data } = await api.postPublishFlows({ ...body, structureVersion })
      dispatch(actions.postingPublishFlowsSuccess(data))
      return data
    } catch (error) {
      dispatch(actions.postingPublishFlowsError(formatError(error)))
    }
  }
}

const updatePublishFlows = (publishFlowId, body) => {
  return async (dispatch, getState) => {
    dispatch(actions.updatingPublishFlows())
    try {
      const { data } = await api.putPublishFlows(publishFlowId, body)
      dispatch(actions.updatingPublishFlowsSuccess(data))
    } catch (error) {
      dispatch(actions.updatingPublishFlowsError(formatError(error)))
      throw formatError(error)
    }
  }
}

const setStructureVersion = version => {
  return async dispatch => {
    dispatch(actions.setStructureVersion(version))
  }
}

export default {
  clearErrors,
  fetchUserNetSuiteAssets,
  fetchUserSites,
  fetchPublishFlows,
  postPublishFlows,
  setStructureVersion,
  updatePublishFlows,
  // New: mutation endpoints for v4
  updateSitePreferences: (siteId, legacyPreferences) => {
    return async (dispatch, getState) => {
      try {
        if (!isV4Routed('updateSitePreferences')) {
          throw new Error('updateSitePreferences not routed to v4')
        }
        const referenceSites = getState()?.ssapiManager?.sites
        const { data } = await api.updateSitePreferences(
          siteId,
          legacyPreferences,
          {
            referenceSites,
          },
        )
        // data expected to be array of all site preferences for that site
        dispatch(
          actions.updateSitePreferences({
            siteId,
            preferences: data.preferences,
          }),
        )
        return data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
  updateSiteUserPreferences: (siteId, legacyPreferences) => {
    return async (dispatch, getState) => {
      try {
        if (!isV4Routed('updateSiteUserPreferences')) {
          throw new Error('updateSiteUserPreferences not routed to v4')
        }
        const referenceSites = getState()?.ssapiManager?.sites
        const { data } = await api.updateSiteUserPreferences(
          siteId,
          legacyPreferences,
          {
            referenceSites,
          },
        )
        // data expected to be array of all site preferences for that site
        dispatch(actions.updateSitePreferences({ siteId, preferences: data }))
        return data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
  updateSitePacingDates: (siteId, programName, pacingUpdate) => {
    return async dispatch => {
      try {
        if (!isV4Routed('updateSitePacingDates')) {
          throw new Error('updateSitePacingDates not routed to v4')
        }
        const { data } = await api.updateSitePacingDates(
          siteId,
          programName,
          pacingUpdate,
        )
        return data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
  updateMspOptInSettings: mspOptInArr => {
    return async dispatch => {
      try {
        const response = await api.updateMspOptInSettings(mspOptInArr)
        return response.data
      } catch (error) {
        throw formatError(error)
      }
    }
  },
}
